import { globalPendingRequestTracker } from './PendingRequestTracker';
import { positionChangeQueue } from './PositionChangeQueue';

export const setupBeforeUnloadHandler = (): (() => void) => {
  const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    const hasPendingRequests = globalPendingRequestTracker.hasPendingRequests();
    const hasPendingPositionChanges = positionChangeQueue.hasPendingRequests();

    if (hasPendingRequests || hasPendingPositionChanges) {
      event.preventDefault();
      event.returnValue = '';
      return '';
    }
  };

  window.addEventListener('beforeunload', handleBeforeUnload);

  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
};
